export function showWipModalIfNeeded() {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return;
  }

  // Check if it already exists to avoid duplicates
  if (document.getElementById('modal-wip')) return;

  const modalHTML = `
    <div id="modal-wip" class="modal-backdrop">
      <div class="glass-panel modal-content" style="max-width: 450px; text-align: center;">
        <h2 style="color: #ffaa00; margin-bottom: 1rem;">Work In Progress - Alpha</h2>
        <p style="font-size: 0.95rem; line-height: 1.5; margin-bottom: 1.5rem; color: #e0e0e0;">
          Welcome! You are viewing an early alpha version of LogSim3D. 
          Please note that this is a work in progress and is not complete. 
          We are constantly improving the simulation, so expect some bugs and incomplete features.
        </p>
        <button id="btn-dismiss-wip" class="glass-btn active" style="width: 100%; padding: 0.75rem;">Dismiss & Continue</button>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  const btn = document.getElementById('btn-dismiss-wip');
  const modal = document.getElementById('modal-wip');
  if (btn && modal) {
    btn.addEventListener('click', () => {
      modal.remove();
    });
  }
}
